const state = {
  snackbar: false,
  snackbarVariant: "",
  snackbarMessage: "",
};

const actions = {
  showSnackbarSuccess({ commit }, message) {
    commit("showSnackbar", { variant: "success", message });
  },
  showSnackbarInfo({ commit }, message) {
    commit("showSnackbar", { variant: "info", message });
  },
  showSnackbarError({ commit }, message) {
    commit("showSnackbar", { variant: "error", message });
  },
};

const mutations = {
  showSnackbar(state, payload) {
    const { variant, message } = payload;

    state.snackbar = true;
    state.snackbarVariant = variant;
    state.snackbarMessage = message;
  },
  snackbarClose(state) {
    state.snackbar = false;
  },
};

export default {
  state,
  actions,
  mutations,
};
